export default __webpack_public_path__ + "static/media/Gingelly_Info.ed2670c0.jpg";